import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import UsersPage from './pages/UsersPage';
import PromotionsPage from './pages/PromotionsPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/users" element={<UsersPage />} />
        <Route path="/promotions" element={<PromotionsPage />} />
    </Routes>
  );
}

export default App;
